var React = require('react');

function Expand (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.38 18.9c0-.02 0-.02.02-.02.52-.16.7-.8.22-1.26-.46-.42-.9-.88-1.34-1.34-.04-.04-.1-.1-.16-.18.06-.06.12-.08.16-.14l3.38-3.38c.28-.279.28-.42 0-.7L8.6 10.82c-.26-.26-.42-.26-.7 0a93857.233 93857.233 0 01-3.56 3.56c-.04-.06-.08-.14-.14-.179-.48-.48-.94-.96-1.42-1.42-.3-.28-.7-.3-.96 0-.1.1-.14.22-.22.32v5.78h.539c1.74.02 3.5.02 5.24.02zM17.64 2.1h-4.78c-.34 0-.6.16-.7.44-.12.3-.04.56.18.78l.74.74c.26.26.52.52.8.78-.06.06-.1.12-.16.16-1.14 1.16-2.28 2.3-3.42 3.44-.22.22-.22.38 0 .6.36.38.74.74 1.1 1.12.28.28.4.28.68 0l2.54-2.54 1-1 .14.14 1.379 1.38c.26.26.54.34.82.2.3-.14.42-.38.42-.7V2.88c.021-.5-.259-.78-.74-.78z","fill":"#C3DBF7"}));
}

Expand.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Expand;

Expand.default = Expand;
